#certifbody span {
    background: url(./Certification.png) no-repeat;
    height: 360px;
    width: 100%;
    display: block;
    background-size: contain;
    background-position: center;
}